// extracted by mini-css-extract-plugin
module.exports = {"bookmark":"Bookmark_bookmark__4hq9c","selected":"Bookmark_selected__dmQ57","skeleton":"Bookmark_skeleton__zcyLG"};